// src/app/_landing/components/ProgressSection.tsx
export const ProgressSection = () => {
  return (
    <section className="w-full px-4 lg:px-8 py-4">
      <div className="max-w-6xl mx-auto">
        <div 
          className="p-8 rounded-2xl border"
          style={{ 
            backgroundColor: '#0C1113',
            borderColor: '#374151'
          }}
        >
          <h2 className="text-2xl font-bold text-white mb-8">Your Progress</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {/* On-chain Tasks */}
            <div className="text-center">
              <div className="text-4xl font-bold mb-2" style={{ color: '#60FF8A' }}>3</div>
              <div style={{ color: '#99A1AF' }}>On-chain Tasks</div>
            </div>
            
            {/* NFTs Owned */}
            <div className="text-center">
              <div className="text-4xl font-bold mb-2" style={{ color: '#60FF8A' }}>5</div>
              <div style={{ color: '#99A1AF' }}>NFTs Owned</div>
            </div>
            
            {/* Friends Referred */}
            <div className="text-center">
              <div className="text-4xl font-bold mb-2" style={{ color: '#60FF8A' }}>8</div>
              <div style={{ color: '#99A1AF' }}>Friends Referred</div>
            </div>
            
            {/* Day Streak */}
            <div className="text-center">
              <div className="text-4xl font-bold mb-2" style={{ color: '#60FF8A' }}>7</div>
              <div style={{ color: '#99A1AF' }}>Day Streak</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
